import { a } from './chunk-IMSWER4T.js';

var n=(e=>(e.All="all",e.AdminUser="admin_user_mode",e.User="user_mode",e.Retailer="retailer_mode",e.None="none",e))(n||{});var i=class{_client=a.instance;async signFile(r){return (await this._client.post("/sign-request",{filename:r.name,contenttype:r.type})).data}async getPublicUrl(r){return (await this._client.get(`/s3/upload/media/public?uploadId=${r}`)).data}};

export { n as a, i as b };
//# sourceMappingURL=chunk-AV47546M.js.map
//# sourceMappingURL=chunk-AV47546M.js.map